import { render } from "./NewArticle.vue?vue&type=template&id=e92e9e0c"
import script from "./NewArticle.vue?vue&type=script&lang=js"
export * from "./NewArticle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__